import { useMutation } from '@tanstack/react-query';
import { sso } from 'apis/auth';
import { AxiosError } from 'axios';

const createSSO = ({ email }: { email?: string }) => sso({ email });

const useMutationCreateSSO = ({
  onSuccess,
  onError,
}: {
  onSuccess: ({
    log_in_method,
    redirect,
  }: {
    log_in_method: string;
    redirect: string;
  }) => void;
  onError: (e: AxiosError) => void;
}) => {
  const { mutate, data, isSuccess, isError } = useMutation(createSSO, {
    onSuccess,
    onError,
  });

  return {
    data,
    mutate,
    isSuccess,
    isError,
  };
};

export default useMutationCreateSSO;
